/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardTypeEntity
 */
export interface CardTypeEntity {
    /**
     * 
     * @type {string}
     * @memberof CardTypeEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeEntity
     */
    cardTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeEntity
     */
    name?: string;
}

export function CardTypeEntityFromJSON(json: any): CardTypeEntity {
    return CardTypeEntityFromJSONTyped(json, false);
}

export function CardTypeEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTypeEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CardTypeEntityToJSON(value?: CardTypeEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardTypeId': value.cardTypeId,
        'name': value.name,
    };
}

